


window.Vlitejs.registerProvider('youtube', window.VlitejsYoutube);
//////////////// FUNCIONES SWIPER RESPONSIVE START //////////
let swiperInstanceRes = null;
let lastBreakpoint = window.innerWidth < 1280 ? "mobile" : "desktop";

function initSwiperRes() {
	let currentBreakpoint = window.innerWidth < 1280 ? "mobile" : "desktop";
	let space = window.innerWidth < 740 ? 16 : 32;

	// Si solo cambia el espacio dentro del mismo breakpoint, lo actualizamos sin destruir Swiper
	if (swiperInstanceRes && currentBreakpoint === lastBreakpoint) {
		swiperInstanceRes.params.spaceBetween = space;
		swiperInstanceRes.update(); // Aplica el nuevo espacio
		return;
	}

	// Si el breakpoint cambia, destruir Swiper y reiniciarlo
	if (swiperInstanceRes) {
		swiperInstanceRes.destroy(true, true);
		swiperInstanceRes = null;
	}

	if (currentBreakpoint === "mobile" && document.querySelector(".c-swiper-last-news")) {
		swiperInstanceRes = new Swiper(".c-swiper-last-news", {
			slidesPerView: "auto",
			spaceBetween: space,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				dynamicBullets: true,
			},
		});
	}

	lastBreakpoint = currentBreakpoint; // Guardamos el nuevo breakpoint
}

//////////////// FUNCIONES SWIPER RESPONSIVE END //////////


//////////////// FUNCIONES HEADER START //////////

document.querySelectorAll('.c-header_menu button.nav-link').forEach(btn => {
	btn.addEventListener('click', () => {
		// Si la pantalla tiene un ancho mayor o igual a 980px
		if (window.matchMedia('(min-width: 980px)').matches) {
			document.querySelectorAll('.collapse-subheader').forEach(collapse => {
				// Si el subencabezado no es el correspondiente al botón clickeado y está abierto
				if (btn.nextElementSibling.id !== collapse.id && collapse.classList.contains('show')) {
					// Cerrar el subencabezado
					new bootstrap.Collapse(collapse, {
						toggle: false
					}).hide();
				}
			});
		}

		// Cambiar el estilo de overflow para la cabecera
		document.querySelector('.c-header_menu').style.overflow = 'hidden';
	});
});

document.querySelectorAll('.c-header_menu .btn-back.first').forEach(btn => {
	btn.addEventListener('click', () => {
		setTimeout(() => {
			document.querySelector('.c-header_menu').style.overflow = 'auto'
		}, 300);
	})
})

function reizeCheckHeaderClose() {
	if (window.innerWidth >= 1280) {
		if (document.body.classList.contains('open-menu')) {
			document.body.classList.remove('open-menu');
		}
		if (document.querySelector('.c-header_menu').classList.contains('show')) {
			document.querySelector('.c-header_menu').classList.remove('show');
		}
		document.querySelectorAll('.collapse-subheader').forEach(col => {
			if (col.classList.contains('show')) {
				col.classList.remove('show');
			}
		})
		if (!document.querySelector('.btn-menu-mov').classList.contains('collapsed')) {
			document.querySelector('.btn-menu-mov').classList.add('collapsed');
		}
	}
}

function controlCollapseHeader() {
	const collapseH = document.getElementById('collapseHeader');
	collapseH.addEventListener('show.bs.collapse', function() {
		document.body.classList.add('open-menu');
	});
	collapseH.addEventListener('hidden.bs.collapse', function() {
		if (window.matchMedia('(min-width: 980px)').matches) {
			setTimeout(() => {
				const allClosed = Array.from(document.querySelectorAll('.collapse-subheader')).every(collapse => !collapse.classList.contains('show'));
				if (allClosed) {
					document.body.classList.remove('open-menu');
				}
			}, 100);

		} else {
			if (document.querySelector('.btn-menu-mov').classList.contains('collapsed')) {
				document.querySelectorAll('.collapse-subheader').forEach(collapse => {
					if (collapse.classList.contains('show')) {
						new bootstrap.Collapse(collapse, {
							toggle: false
						}).hide();
					}
				})
				document.body.classList.remove('open-menu');
				document.body.classList.remove('open-submenu');
			}
		}
	});
}

document.querySelector(".backdrop").addEventListener("click", () => {
	document.querySelectorAll('.c-header_menu').forEach(collapseH => {
		if (collapseH.classList.contains('show')) {
			const collapseHInstance = bootstrap.Collapse.getInstance(collapseH);
			collapseHInstance.hide();
		}
	});

	document.querySelectorAll('.collapse-subheader').forEach(collapse => {
		if (collapse.classList.contains('show')) {
			const collapseInstance = bootstrap.Collapse.getInstance(collapse);
			collapseInstance.hide();
		}
	});

});
document.querySelectorAll(".collapse-subheader_list .title.btn").forEach(link => {
	link.addEventListener('click', (e) => {
		//console.log('holis', link.closest('.collapse-subheader') )
		link.nextElementSibling.classList.add('show')
		// link.closest('.collapse-subheader').style.overflow = 'hidden';
	})
})
document.querySelectorAll('.btn-back-sub').forEach(btn => {
	btn.addEventListener('click', () => {
		btn.parentElement.classList.remove('show')
	})
})
//////////////// FUNCIONES HEADER END //////////


if (document.querySelector('.swiper-header')) {
	document.querySelectorAll('.swiper-header').forEach(swiperH => {
		const swiperInstance = new Swiper(swiperH, {
			slidesPerView: "auto",
			spaceBetween: 40,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			mousewheel: {
				releaseOnEdges: true,
			},
		});
	});
}

//////////////// VIMEO START//////////

const videos = document.querySelectorAll('.vlite-js');
const videoInstance = [];

videos.forEach(video => {
	const poster = video.dataset.poster;
	const options = {
		controls: true,
		volume: true,
		fullscreen: true,
		loop: false,
		muted: true,
		playPause: true,
		progressBar: true,
		time: true,
		bigPlay: true,
		autoplay: false,
		poster: poster
	};

	let provider = null;
	if (video.classList.contains('yt')) {
		provider = "youtube";
	}
	const vliteConfig = { options };

	if (provider) {
		vliteConfig.provider = provider;
	}

	const vid = new Vlitejs(video, vliteConfig);

	vid.onReady = function(player) {
		videoInstance.forEach((vI) => {
			if (vI.id === player.media.id) {
				vI.player = player;
			}
		});
	};

	videoInstance.push({ id: video.id, video: vid, player: null });
});


//////////////// VIMEO END//////////


//////////////// BTN SCROLL UP START//////////

const scrollUpBtn = document.getElementById('scrollUpBtn');

// Mostrar el botón cuando se baja 300px o más
window.addEventListener('scroll', function() {
	if (window.scrollY > 300) {
		scrollUpBtn.classList.add('show');
	} else {
		scrollUpBtn.classList.remove('show');
	}
});

// Scroll suave al top cuando se hace clic
scrollUpBtn.addEventListener('click', function() {
	window.scrollTo({
		top: 0,
		behavior: 'smooth'
	});

	scrollUpBtn.blur();
});

//////////////// BTN SCROLL UP END//////////

//////////////// SWIPER DEFUALT START//////////
if (document.querySelector('.swiper-default')) {
	document.querySelectorAll('.swiper-default').forEach(swiperC => {
		const swiperInstance = new Swiper(swiperC, {
			slidesPerView: "auto",
			spaceBetween: 16,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				dynamicBullets: true,
			},
		});

		// Verificamos si Swiper debe activarse o no
		checkSlides(swiperC, swiperInstance);
	});
}

function checkSlides(swiperC, swiperInstance) {
	let swiperWrapper = null;
	if (swiperC) {
		swiperWrapper = swiperC.querySelector(".swiper-wrapper");
	}
	if (!swiperWrapper) return;

	// Ancho total de los slides
	const slidesTotalWidth = swiperWrapper.scrollWidth;
	// Ancho visible del swiper
	const swiperVisibleWidth = swiperC.clientWidth;


	if (slidesTotalWidth > swiperVisibleWidth) {
		swiperC.parentElement.classList.add("active");
		swiperInstance.enable();
	} else {
		swiperC.parentElement.classList.remove("active");
		swiperInstance.disable();
	}
}

//////////////// SWIPER DEFUALT END//////////
const ignoreNextScroll = new WeakMap();

// Añadir listeners para saber cuándo el usuario abre manualmente un collapse
document.querySelectorAll('.c-filtros .collapse').forEach((collapseEl) => {
	collapseEl.addEventListener('show.bs.collapse', () => {
		// Ignorar el próximo scroll durante 500ms
		ignoreNextScroll.set(collapseEl, true);
		setTimeout(() => {
			ignoreNextScroll.set(collapseEl, false);
		}, 500); // puedes ajustar el tiempo si es necesario
	});
});

function checkSticky() {
	document.querySelectorAll(".c-catalog").forEach((catalog) => {
		const filtros = catalog.querySelector(".c-filtros");
		const card = catalog.querySelector(".c-card-presu");
		const tabla = catalog.querySelector(".c-catalog_list");

		if (!filtros || !tabla) return;

		const tablaBottom = tabla.getBoundingClientRect().bottom;

		if (card) {
			const cardBottom = card.getBoundingClientRect().bottom;
			if (cardBottom === tablaBottom) {
				filtros.classList.add("stop-sticky");
			} else {
				filtros.classList.remove("stop-sticky");
			}
		}

		const rect = filtros.getBoundingClientRect();
		const collapseElement = catalog.querySelector(".c-filtros .collapse");

		if (collapseElement && rect.top <= 0) {
			// Verificar si hay que ignorar el cierre por scroll
			if (!ignoreNextScroll.get(collapseElement)) {
				const bsCollapse = new bootstrap.Collapse(collapseElement, { toggle: false });
				bsCollapse.hide();
			}
		}
	});
}
// function checkSticky() {
//   document.querySelectorAll(".c-catalog").forEach((catalog) => {
//     const index = catalog.getAttribute('data-index');
//     const filtros = catalog.querySelector(".c-filtros");
//     const card = catalog.querySelector(".c-card-presu");
//     const tabla = catalog.querySelector(".c-catalog_list");

//     // Obtener posición bottom de la tarjeta y la tabla
//     const tablaBottom = tabla.getBoundingClientRect().bottom;

//     // Si la tarjeta ha llegado al final de la tabla, quitar sticky a los filtros
//     if(card) {
//       const cardBottom = card.getBoundingClientRect().bottom;
//       if (cardBottom == tablaBottom) {
//         filtros.classList.add("stop-sticky");
//       } else {
//         filtros.classList.remove("stop-sticky");
//       }
//     }
//     const stickyElement = filtros;
//     const rect = stickyElement.getBoundingClientRect();
//     // const collapseElement = catalog.querySelector(".collapse");
//     if(catalog.querySelector(".c-filtros .collapse")) {
//       const bsCollapse = new bootstrap.Collapse(catalog.querySelector(".c-filtros .collapse"), { toggle: false });
//       if (rect.top <= 0) {
//         bsCollapse.hide();
//       }
//     }

//   });
// }

if (document.querySelector('.c-catalog')) {
	document.addEventListener("scroll", checkSticky);
}

//////////////// FILTROS STICKY END//////////

//////////////// CTAS MOVIL FIXED START //////////
function hideCtas() {
	const fixedCtas = document.querySelector(".c-fixed-ctas");
	const footer = document.querySelector(".c-footer");
	const collapseElement = fixedCtas.querySelector(".collapse");

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					fixedCtas.classList.add("hide");

					if (collapseElement && collapseElement.classList.contains("show")) {
						const collapseInstance = bootstrap.Collapse.getInstance(collapseElement) || new bootstrap.Collapse(collapseElement);
						collapseInstance.hide();
					}
				} else {
					fixedCtas.classList.remove("hide");
				}
			});
		},
		{ threshold: 0.1 }
	);

	observer.observe(footer);
}
//////////////// CTAS MOVIL FIXED END //////////

//////////////// SWIPER HOME START //////////
if (document.querySelector(".c-hero_swiper")) {
	var swiper = new Swiper(".c-hero_swiper", {
		autoplay: {
			delay: 6000,
			disableOnInteraction: false,
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
	});
}
//////////////// SWIPER HOME END //////////

//////////////// SWIPER FILROS START //////////
if (document.querySelector(".js-swiper-filtros")) {
	var swiper = new Swiper(".js-swiper-filtros", {
		slidesPerView: "auto",
		spaceBetween: 16,
		freeMode: true,

		scrollbar: {
			el: ".swiper-scrollbar",
			// hide: false,
		},
	});
}

//////////////// SWIPER FILROS end //////////


function toggleLegendCollapse() {
	const colLegend = document.getElementById('colLegend');
	const collapse = bootstrap.Collapse.getOrCreateInstance(colLegend);
	if (window.innerWidth > 1280) {
		collapse.show();
	} else {

		collapse.hide();
	}
}


////////////////  LIGHTGALLERT START //////////
if (document.querySelector('.js-lightgallery')) {
	document.querySelectorAll('.js-lightgallery').forEach(gallery => {
		lightGallery(gallery, {
			selector: 'a.js-gall',
			speed: 500,
			plugins: [lgVideo],
			download: false,
			licenseKey: '9FE1C2A6-A8A3-424E-B3D8-B9172C0CF11B'
		});
	})
}
////////////////  LIGHTGALLERT END //////////

////////////////  HEADER TABLET SCROLL START //////////
let lastScroll = 0;
const header = document.querySelector('.c-header');

function handleScroll() {
	const currentScroll = window.scrollY;

	// Solo aplica si el viewport es menor o igual a 980px
	if (window.innerWidth <= 980) {
		if (currentScroll > lastScroll && currentScroll > 50) {
			// Scroll hacia abajo
			header.classList.add('hide');
		} else {
			// Scroll hacia arriba
			header.classList.remove('hide');
		}
	} else {
		// Asegura que el header esté visible en pantallas grandes
		header.classList.remove('hide');
	}

	lastScroll = currentScroll;
}

////////////////  HEADER TABLET SCROLL END//////////
function initApp() {
	if (document.getElementById('colLegend')) {
		toggleLegendCollapse()
	}
	controlCollapseHeader();
	initSwiperRes();
	reizeCheckHeaderClose();
	checkSlides();
	handleScroll();
	if (document.querySelector(".c-fixed-ctas") && window.matchMedia("(max-width: 980px)").matches) {
		hideCtas();
	}
}

function handleResize() {
	if (document.getElementById('colLegend')) {
		toggleLegendCollapse()
	}
	initSwiperRes();
	reizeCheckHeaderClose();
	handleScroll();
	document.querySelectorAll('.swiper-default').forEach(swiperC => {
		const swiperInstance = swiperC.swiper; // Swiper almacena la instancia en el propio contenedor
		if (swiperInstance) checkSlides(swiperC, swiperInstance);
	});
	if (document.querySelector(".c-fixed-ctas") && window.matchMedia("(max-width: 980px)").matches) {
		hideCtas();
	}
}



window.addEventListener("resize", handleResize);
document.addEventListener("DOMContentLoaded", initApp);
window.addEventListener('scroll', handleScroll);

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function(tooltipTriggerEl) {
	return new bootstrap.Tooltip(tooltipTriggerEl)
})
	const sliders = document.querySelectorAll('.list-radios');
	sliders.forEach(slider=> {
		if (!slider) {
		  // Esperamos y volvemos a intentar en 100ms
		  setTimeout(initGrabScroll, 100);
		  return;
		}
	  
		let isDown = false;
		let startX;
		let scrollLeft;
	  
		slider.addEventListener('mousedown', (e) => {
		  isDown = true;
		  startX = e.pageX - slider.offsetLeft;
		  scrollLeft = slider.scrollLeft;
		});
	  
		slider.addEventListener('mouseleave', () => {
		  isDown = false;
		});
	  
		slider.addEventListener('mouseup', () => {
		  isDown = false;
		});
	  
		slider.addEventListener('mousemove', (e) => {
		  if (!isDown) return;
		  e.preventDefault();
		  const x = e.pageX - slider.offsetLeft;
		  const walk = (x - startX) * 5;
		  slider.scrollLeft = scrollLeft - walk;
		});
	})
